import { render, staticRenderFns } from "./CentralizedPlan.vue?vue&type=template&id=2564ae00&scoped=true&"
import script from "./CentralizedPlan.vue?vue&type=script&lang=js&"
export * from "./CentralizedPlan.vue?vue&type=script&lang=js&"
import style0 from "./CentralizedPlan.vue?vue&type=style&index=0&id=2564ae00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2564ae00",
  null
  
)

export default component.exports